// extracted by mini-css-extract-plugin
export var statItem = "_me-1";
export var statsRow = "_me-0";